<template>
    <v-app-bar app color="blue darken-2" dark>
      <v-app-bar-nav-icon @click="toggleNavigationBar"></v-app-bar-nav-icon>
      <v-toolbar-title>
        <span v-if="name" class="font-weight-bold font-weight-black title">{{name}}</span>
        <span v-else class="font-weight-bold font-weight-black title">CREDITARIA</span>
      </v-toolbar-title>
      <div class="flex-grow-1"></div>
  <!--     <v-btn icon>
        <v-icon>mdi-heart</v-icon>
      </v-btn> -->
    </v-app-bar>
</template>

<script>
export default {
  props: ['name'],
  data () {
    return {}
  },
  methods: {
    toggleNavigationBar () {
      const vm = this
      vm.$emit('toggleNavigationBar')
    }
  }
}
</script>
